import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const AddPrivacyPolicy = ({ onCreate }) => {
    const [formData, setFormData] = useState({
        policy: '',
        status: false,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [checking, setChecking] = useState(true);
    const navigate = useNavigate();

    // Guard: if a policy already exists, don't allow creating a second one
    useEffect(() => {
        const checkExisting = async () => {
            try {
                const res = await axios.get('https://api.sofiasurgicals.com/api/get-PrivacyPolicy');
                // Already exists — redirect to edit instead
                toast.info('Privacy Policy already exists. Redirecting to edit.');
                navigate(`/edit-PrivacyPolicy/${res.data._id}`, { replace: true });
            } catch (err) {
                if (err.response?.status === 404) {
                    setChecking(false); // safe to show create form
                } else {
                    console.error(err);
                    setChecking(false);
                }
            }
        };

        checkExisting();
    }, [navigate]);

    const handlePolicyChange = (policy) => {
        setFormData((prev) => ({ ...prev, policy }));
    };

    const handleStatusChange = (e) => {
        setFormData((prev) => ({ ...prev, status: e.target.checked }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await axios.post('https://api.sofiasurgicals.com/api/add-PrivacyPolicy', formData, {
                headers: { 'Content-Type': 'application/json' },
            });
            toast.success('Privacy Policy created successfully!');
            if (onCreate) onCreate();
            navigate('/all-PrivacyPolicy');
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Failed to create Privacy Policy');
        } finally {
            setIsLoading(false);
        }
    };

    if (checking) {
        return <p className="text-center mt-4">Checking existing policy...</p>;
    }

    return (
        <>
            <ToastContainer />
            <div className="bread d-flex justify-between items-center mb-4">
                <h4>Create Privacy Policy</h4>
            </div>

            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-12">
                    <label className="form-label">Privacy Policy Content</label>
                    <JoditEditor
                        value={formData.policy}
                        onChange={handlePolicyChange}
                        config={{ readonly: false }}
                    />
                </div>

                <div className="col-md-6 form-check">
                    <input
                        type="checkbox"
                        name="status"
                        className="form-check-input"
                        checked={formData.status}
                        onChange={handleStatusChange}
                        id="statusCheckbox"
                    />
                    <label className="form-check-label" htmlFor="statusCheckbox">
                        Active
                    </label>
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Please Wait...' : 'Create Privacy Policy'}
                    </button>
                </div>
            </form>
        </>
    );
};

export default AddPrivacyPolicy;